<template>
    <div class="record-cost-unit-workshop-invoice-positions">
        <b-row>
            <b-col>
                <b-row>
                    <b-col cols="8">
                        <h2>Werkstattrechnung</h2>
                    </b-col>
                    <b-col cols="4" style="text-align: right">
                        <b-button @click="toggleCollapse">
                            {{ collapseToggleLabel }}
                        </b-button>
                    </b-col>
                </b-row>
                <div v-show="!collapsed">
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="AW pro Stunde"
                            property="workUnitsPerHour"
                            type="number"
                            @change="onChangeWorkUnitsPerHour"/>
                    </b-row>
                    <h3>Karosserie</h3>
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="AW"
                            property="bodyWorkWorkUnits"
                            type="number"
                            @change="onChangeBodyWork"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Stundensatz"
                            property="bodyWorkHourlyRate"
                            type="currency"
                            @change="onChangeBodyWork"
                            @input="onChangeBodyWork"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Summe"
                            property="bodyWorkTotal"
                            type="currency"/>
                    </b-row>
                    <h3>Lackierung</h3>
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="AW"
                            property="lacquerWorkUnits"
                            type="number"
                            @change="onChangeLacquer"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Stundensatz"
                            property="lacquerHourlyRate"
                            type="currency"
                            @change="onChangeLacquer"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Summe"
                            property="lacquerTotal"
                            type="currency"/>
                    </b-row>
                    <h3>Sonstiges</h3>
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Lackmaterial"
                            property="lacquerMaterial"
                            type="currency"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Ersatzteile Summe"
                            property="sparePartsTotal"
                            type="currency"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="formContext"
                            label="Nebenkosten"
                            property="additionalCosts"
                            type="currency"/>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <hr>
    </div>
</template>

<script>
import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

export default {
    name: 'CostUnitWorkshopInvoicePositions',
    mixins: [FormDataMixin],
    data() {
        return {
            collapsed: true,
        }
    },
    computed: {
        collapseToggleLabel() {
            return this.collapsed ? 'ausklappen' : 'einklappen';
        },
    },
    methods: {
        onChangeWorkUnitsPerHour() {
            this.onChangeBodyWork();
            this.onChangeLacquer();
        },
        onChangeBodyWork() {
            if (
                Number(this.formContext.form.getProperty('workUnitsPerHour'))
                && this.formContext.form.getProperty('bodyWorkHourlyRate')
                && this.formContext.form.getProperty('bodyWorkWorkUnits')
            ) {
                this.formContext.form.setProperty(
                    'bodyWorkTotal',
                    this.formContext.form.getProperty('bodyWorkHourlyRate')
                    * Number(this.formContext.form.getProperty('bodyWorkWorkUnits'))
                    / Number(this.formContext.form.getProperty('workUnitsPerHour'))
                );
            } else {
                this.formContext.form.setProperty('bodyWorkTotal', null)
            }
        },
        onChangeLacquer() {
            if (
                Number(this.formContext.form.getProperty('workUnitsPerHour'))
                && this.formContext.form.getProperty('lacquerHourlyRate')
                && this.formContext.form.getProperty('lacquerWorkUnits')
            ) {
                this.formContext.form.setProperty(
                    'lacquerTotal',
                    this.formContext.form.getProperty('lacquerHourlyRate')
                    * Number(this.formContext.form.getProperty('lacquerWorkUnits'))
                    / Number(this.formContext.form.getProperty('workUnitsPerHour'))
                );
            } else {
                this.formContext.form.setProperty('lacquerTotal', null)
            }
        },
        toggleCollapse() {
            this.collapsed = !this.collapsed;
        },
    },
}
</script>
